import { ISearchPrep } from "@/types/search";

const Ascorbin = '/img/temp/ascorbin.jpg'
const Masks = '/img/temp/masks.jpg'
const Glukoza = '/img/proizv/preps/glukoza.jpg'
const Antigrippin1 = '/img/proizv/preps/antigrippin.jpg'
const Protargol1 = '/img/proizv/preps/protargol.jpg'
const Protargol2 = '/img/proizv/preps/protargol-1.jpg'
const Protargol3 = '/img/proizv/preps/protargol-2.jpg'

const apiHost = process.env.NEXT_PUBLIC_API_URL || 'https://zakaz-backend.ttmf.ru';

const images: { [key: number]: string } = {
  150482: Antigrippin1,
  150480: Antigrippin1,
  149940: Antigrippin1,
  132439: Protargol1,
  129800: Protargol2,
  117000: Protargol2,
  102987: Protargol3,
  129801: Protargol3,
  273932: Ascorbin,
  154403: Glukoza,
  265180: Masks
}

export const fillImages = (preps: ISearchPrep[]) => {
  for(let i = 0; i < preps.length; i++) {
    if(preps[i].picname) {
      // Убираем лишний слеш, если NEXT_PUBLIC_API_URL может прийти со слешем на конце
      const baseUrl = apiHost.endsWith('/') ? apiHost.slice(0, -1) : apiHost;
      preps[i].image = `${baseUrl}/files/preps/${preps[i].picname}`;
      continue;
    }
    if(images[preps[i].id]) {
      preps[i].image = images[preps[i].id];
    }
  }
}